export default __webpack_public_path__ + "static/media/blocks.62f80ab4.jpg";